import React from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
    wallet_btn:{
        width:'73%',
        marginTop:'10px',
        alignSelf:'center',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        border:'1px solid #e4e8ed',
        marginBottom:'10px',
        borderRadius:'8px',
        marginBottom:"10px",
        [theme.breakpoints.between('xs','md')]: {
            width:'100%'
		},
    },

    wallet_innDiv:{
        backgroundColor: 'transparent',
        borderBottom: 'none',
        marginBottom: -1,
        minHeight: 56,
        height:'auto',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        cursor:'pointer',
        transition:'0.4s',
        backgroundColor:'transparent',
        padding:'5px 10px',
    },

    walletInDiv:{
        display:'flex',
        flexDirection:'column',
    },

    walletHead:{
        color: '#0F467A',
        fontSize:'13px',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'11px'
        },
    },

    panelTitle:{
        color:'#000',
        fontWeight:'bold',
        fontFamily:"'Poppins', sans-serif",
    },

    payButton:{
        whiteSpace: 'nowrap',
        border: 0,
        outline: 0,
        display: 'inline-block',
        padding: '8px 14px',
        boxShadow: '0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%)',
        color: '#fff',
        borderRadius: '4px',
        fontSize: '15px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.025em',
        border: '2px solid #0F467A',
        color:'#0F467A',
        textDecoration: 'none',
        transition: 'all 150ms ease'
    }
})

class OnSitePay extends React.Component {

    render() {
        const { loading, classes, t, i18n, pushReservation } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.wallet_btn}>
            <div className={classes.wallet_innDiv}>
                <div className={classes.walletInDiv}>
                    <span className={classes.panelTitle} style={{fontFamily}}>{t('companyPage.bookNow')}</span>
                    <span className={classes.walletHead} style={{fontFamily}}>{t('booking.onsiteDis')}</span>
                </div>
                <div className={classes.priceSection}>
                    <button type='button' className={classes.payButton} onClick={()=>pushReservation()} style={{fontFamily}}>{loading ? `${t('companyPage.bookNow')}...` : t('companyPage.bookNow')}</button>
                </div>
            </div>
        </div>
    )}
}

export default withStyles(styles)(withTranslation('common')(OnSitePay));